//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userCheckoutStore } from "~/stores/checkout-store";
import { storeToRefs } from "pinia";
import { defineComponent, computed, useContext  } from '@nuxtjs/composition-api'
import AppHeader from "~/components/AppHeader.vue";
import TabMenu from "~/components/TabMenu.vue";
import BRXComponentMethods from '~/helpers/BRXComponentMethods'
import AppSimplifiedHeader from "~/components/AppSimplifiedHeader.vue";
import { checkCMSFlag } from "~/helpers/globalLabels";


export default defineComponent({
  name: "Header",
  components: { AppSimplifiedHeader, AppHeader, TabMenu },
  props: {
    component: {},
    page: {},
  },
  methods: {
    getDocument() {
      return BRXComponentMethods.getDocument(this.component, this.page);
    },
    getImage(imageRef) {
      return BRXComponentMethods.getImage(imageRef, this.page);
    },
    extractComponent(data) {
      return BRXComponentMethods.extractComponent(data, this.page, this.properties);
    },
    getData(type) {
      const types = ['placeholder', 'account', 'cart', 'search'];

      if(!this.mappedComponent || types.indexOf(type) === -1) return null;

      if(type === 'placeholder') {
        return this.mappedComponent.placeholder
      }

      const index = this.mappedComponent.items.findIndex(item => item.iconName === type);

      return this.mappedComponent.items[index];

    }
  },
  computed: {
    document() {
      return this.getDocument()
    },
    mappedComponent() {
      if(this.document)
        return this.extractComponent(this.document.getData())
      return null;
    },
    _suggestionsPlaceholder() {
      if(this.mappedComponent?.search_suggetions_placeholder)
        return this.mappedComponent.search_suggetions_placeholder
      return "Search suggestions"
    },
    _topSearchesPlaceholder() {
      if(this.mappedComponent?.top_searches_placeholder)
        return this.mappedComponent.top_searches_placeholder
      return "Top searches"
    },
    _noSuggestionsPlaceholder() {
      if(this.mappedComponent?.no_suggestions_placeholder)
        return this.mappedComponent.no_suggestions_placeholder
      return "No suggestion found."
    },
    _benefitBarData() {
      if(this.mappedComponent?.benefit_bar_data)
        return this.mappedComponent.benefit_bar_data
    },
    _tabMenu() {
      const tabMenuItems = this.mappedComponent?.tabMenu?.tabMenuItem;

      if(!tabMenuItems) return []

      return tabMenuItems.map(item => {
        const scrollToSection = item.scrollTo.selectionValues[0].key !== "null" ? item.scrollTo.selectionValues[0].key : null;

        return {
          button: item.buttonText,
          link: item.linkTo,
          ariaLabel: item.ariaLabel,
          scrollable: scrollToSection,
        }
      })
    },
  },
  setup() {
    const { i18n } = useContext();
    const store = userCheckoutStore();

    const appKey = i18n.localeProperties.appKey;
    const { cartItemsCount}  = storeToRefs(store);
    const cartTotalItems = computed(() => {
      return cartItemsCount.value[appKey];
    });

    const isSimplifiedHeaderEnable = checkCMSFlag('simplified-header-flag', 'true');

    return {
      isSimplifiedHeaderEnable,
      cartTotalItems
    }
  }
})
